const useDictionary = (value, dictionary) => {
  if (!dictionary[value]) {
    return value;
  }
  return dictionary[value];
};

export default useDictionary;
